import { render } from "./AddAccountForm.vue?vue&type=template&id=bf447fec&scoped=true"
import script from "./AddAccountForm.vue?vue&type=script&lang=js"
export * from "./AddAccountForm.vue?vue&type=script&lang=js"

import "./AddAccountForm.vue?vue&type=style&index=0&id=bf447fec&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf447fec"]])

export default __exports__